import React, {useEffect, useState} from "react";
import {postEvent} from '@telegram-apps/sdk';


import {useSearchParams} from "react-router-dom";
import {useDom} from "../context/dom";

import {GoogleGenAI} from "@google/genai";


const Intro = (p) => {
  const [text, setText] = useState(null);
  const ai = new GoogleGenAI({ apiKey: process.env.REACT_APP_GEMINI });
 // const genAI = new GoogleGenerativeAI(process.env.REACT_APP_GEMINI);
 // const model = genAI.getGenerativeModel({model: "gemini-2.5-flash"});








  useEffect(() => {
    const prompt =
      "Create a picture of a nano banana dish in a fancy restaurant with a Gemini theme";

    const response =  ai.models.generateContent({
      model: "gemini-2.5-flash-image-preview",
      contents: prompt,
    });
    if (response.candidates){
    for (const part of response.candidates[0].content.parts) {
      if (part.text) {
        console.log(part.text);
      } else if (part.inlineData) {
        const imageData = part.inlineData.data;
        const buffer = Buffer.from(imageData, "base64");
        //fs.writeFileSync("gemini-native-image.png", buffer);
        //console.log("Image saved as gemini-native-image.png");
      }
    }}

  }, []);
  return (
<>
    {
      text &&
    (
      <div dangerouslySetInnerHTML={{__html:text}}></div>
    )
}
</>
)
}

export default function FarmAI(props) {


  /* */


  const dom = useDom();
  const [searchParams, setSearchParams] = useSearchParams();


  const [page, setPage] = useState([]);
  let num;

  let tms = 1;
  let nn = 0;
  const links = [];
  const pgss = [];
  const swp = (e) => {

    console.log(e)

  }

  const share = (a) => {

    window.Telegram.WebApp.shareToStory(a.source_url, {text: a.excerpt.rendered.replace(/<\/?[^>]+(>|$)/g, '') + '...'});
  }


  const openL = (a) => {


    postEvent('web_app_open_link', {url: a.link, try_instant_view: true});
    // window.Telegram.WebApp.web_app_open_link()

  }

  useEffect(() => {


    //window.Telegram.WebApp.initDataUnsafe.user &&  console.log(window.Telegram.WebApp.initDataUnsafe.user);
    num = 0;
    if (window.Telegram.WebApp.initDataUnsafe.user) {
      window.Telegram.WebApp.setHeaderColor('#000000');
      window.Telegram.WebApp.setBackgroundColor('#000000');
      window.Telegram.WebApp.setBottomBarColor('#000000');

    }


    const n = 1;
   // getPost(n);
    //   getIm(n);

  }, []);
  return (
    <div className="bg-black pt-4" style={{maxWidth: '480px'}}>
      <Intro />
    </div>
  );
}
